import React, { useState } from 'react';
import { Paragraph, SectionSubtitle } from '../Typography';
import ProfileContent from 'src/data/ProfileContent';
import { ArrowPurple } from 'src/components/Icons/arrows';
import { mediaQueries } from 'src/style/breakpoints';
import colors from 'src/style/colors';
import {
  Arrow,
  ProfileItem,
  ProfileListItems,
  ProfileDropDownMenu,
  ProfileSelected,
} from './elements';

const Profile = ({ defaultIndex, fromFormationsPageType }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [state, setProfile] = useState({
    profile: ProfileContent[defaultIndex].label,
    text: ProfileContent[defaultIndex].text,
  });

  return (
    <div css={{ padding: '60px 0px 60px 0px' }}>
      <SectionSubtitle
        css={{
          display: 'flex',
          flexDirection: 'row',
          [mediaQueries.phoneOnly]: {
            flexDirection: 'column',
          },
        }}
      >
        Je suis
        <ProfileDropDownMenu
          onMouseEnter={() => setIsOpen(true)}
          onClick={() => setIsOpen(!isOpen)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <ProfileSelected isOpen={isOpen}>
            <span
              css={
                !isOpen && {
                  borderBottom: `5px ${colors.purple} solid`,
                  [mediaQueries.phoneOnly]: {
                    borderBottom: `4px ${colors.purple} solid`,
                  },
                }
              }
            >
              {state.profile}
            </span>

            <Arrow isOpen={isOpen}>
              <ArrowPurple />
            </Arrow>
          </ProfileSelected>
          <ProfileListItems isOpen={isOpen} fromFormationsPageType={fromFormationsPageType}>
            {ProfileContent.filter((item) => {
              if (
                item.label !== state.profile &&
                item.formation.indexOf(fromFormationsPageType) !== -1
              )
                return item;
            }).map((item) => (
              <ProfileItem
                onClick={() => {
                  setProfile((state) => ({ ...state, profile: item.label, text: item.text }));
                  setIsOpen(false);
                }}
                key={item.id}
              >
                {item.label}
              </ProfileItem>
            ))}
          </ProfileListItems>
        </ProfileDropDownMenu>
      </SectionSubtitle>
      <Paragraph css={{ paddingBottom: 0, paddingTop: isOpen ? 15 : 10 }}>{state.text}</Paragraph>
    </div>
  );
};

export default Profile;
